var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 7.83333V13.1667C13.8333 15.0047 12.338 16.5 10.5 16.5H3.83333C1.99533 16.5 0.5 15.0047 0.5 13.1667V6.5C0.5 4.662 1.99533 3.16667 3.83333 3.16667H9.16667C9.53467 3.16667 9.83333 3.46533 9.83333 3.83333C9.83333 4.20133 9.53467 4.5 9.16667 4.5H3.83333C2.73067 4.5 1.83333 5.39733 1.83333 6.5V13.1667C1.83333 14.2693 2.73067 15.1667 3.83333 15.1667H10.5C11.6027 15.1667 12.5 14.2693 12.5 13.1667V7.83333C12.5 7.46533 12.7987 7.16667 13.1667 7.16667C13.5347 7.16667 13.8333 7.46533 13.8333 7.83333ZM14.5 0.5H9.83333C9.46533 0.5 9.16667 0.798667 9.16667 1.16667C9.16667 1.53467 9.46533 1.83333 9.83333 1.83333H14.224L6.02867 10.0287C5.768 10.2893 5.768 10.7107 6.02867 10.9713C6.15867 11.1013 6.32933 11.1667 6.5 11.1667C6.67067 11.1667 6.84133 11.1013 6.97133 10.9713L15.1667 2.776V7.16667C15.1667 7.53467 15.4653 7.83333 15.8333 7.83333C16.2013 7.83333 16.5 7.53467 16.5 7.16667V2.5C16.5 1.39733 15.6027 0.5 14.5 0.5Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAll);
export default __webpack_public_path__ + "static/media/viewAll.e42d677ab301877ac0e1f12005788ab4.svg";
export { ForwardRef as ReactComponent };